// ShiftHistory.jsx
import Badge from './ShiftStatusBadge';

export default function ShiftHistory({ shiftHistory }) {
  return (
    <div className="space-y-3 max-h-60 overflow-y-auto">
      {shiftHistory.map((shift, idx) => (
        <div
          key={idx}
          className="flex items-center p-3 bg-white/50 rounded-lg hover:bg-white/70 transition-colors"
        >
          <div
            className={`w-3 h-3 rounded-full mr-3 ${
              shift.type === 'in' ? 'bg-emerald-500' : 'bg-amber-500'
            }`}
          ></div>
          <div className="flex-1">
            <div className="font-medium">{shift.time}</div>
            <div className="text-sm text-gray-500">{shift.date}</div>
          </div>
          <Badge variant={shift.type}>
            {shift.type === 'in' ? 'Check In' : 'Check Out'}
          </Badge>
        </div>
      ))}
    </div>
  );
}
